import '@static/index.css';
import '@toggle/design-system/src/design-tokens/_radix-colors.scss';
import '@toggle/design-system/src/design-tokens/themes/themes.scss';
import '~/utils/i18n/i18n';

import { FloatingDelayGroup } from '@floating-ui/react';
import { app } from '@microsoft/teams-js';
import { QueryClientProvider } from '@tanstack/react-query';
import { Routes } from '@teams/routes';
import { getApplicationContainer } from '@toggle/helpers';
import * as React from 'react';
import { createRoot } from 'react-dom/client';

import { queryClient } from '~/services/query-client/queryClient';

const renderApp = () => {
  const root = createRoot(getApplicationContainer());

  root.render(
    <QueryClientProvider client={queryClient}>
      <FloatingDelayGroup delay={{ open: 300, close: 0 }} timeoutMs={300}>
        <Routes />
      </FloatingDelayGroup>
    </QueryClientProvider>
  );
};

// app.initialize() only resolves inside the Teams client.
// Outside Teams (direct browser, dev mode) it rejects — render anyway.
app
  .initialize()
  .catch(() => {})
  .finally(renderApp);
